/** Use for bind and unbind brands for brand manager*/
export class StaffBrandDto {
    constructor(readonly brand_manager_id: number, readonly brand_id: number) {}
}
